import queries from '@apis/queries';
import AuthGuard from '@components/AuthGuard';
import Image from '@components/Image';
import colors from '@constants/colors';
import { css } from '@emotion/css';
import styled from '@emotion/styled';
import useUser from '@hooks/auth/useUser';
import useAppCustom from '@hooks/useAppCustom';
import { Link } from '@router/Link';
import { isSidebarOpenAtom } from '@states/uiAtoms';
import { useQuery } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';

import BellIcon from './BellIcon';
import MenuIcon from './MenuIcon';

function Header() {
    const setSidebar = useSetAtom(isSidebarOpenAtom);
    const openSidebar = () => setSidebar(true);
    const { logo } = useAppCustom().main;
    const { user } = useUser();
    const { data } = useQuery({
        ...queries.notifications.unread(),
        enabled: !!user,
    });
    const guardClass = css`width: 30px;`;
    return (
        <Container>
            <SideButton onClick={openSidebar}>
                <MenuIcon/>
            </SideButton>
            {logo && (<LogoImage src={logo} alt='logo' />)}
            <AuthGuard className={guardClass}>
                <Link activityName='NotificationActivity'
                    activityParams={{}} >
                    <SideButton>
                        <BellIcon/>
                        {data?.hasUnread && (<Dot/>)}
                    </SideButton>
                </Link>
            </AuthGuard>
        </Container>
    );
}

const Container = styled.header`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: calc(16px + var(--safe-area-top)) 18px 16px;
    align-items: flex-end;
    background-color: white;
    gap: 16px;
`;

const SideButton = styled.button`
    align-items: center;
    background-color: var(--color-gray2);
    border-radius: 15px;
    display: flex;
    height: 30px;
    justify-content: center;
    padding: 0;
    width: 30px;
    min-width: 30px;
    position: relative;
`;

const LogoImage = styled(Image)`
    height: 30px;
    //aspect-ratio: 2.3;
    object-fit: contain;
    width: 100%;
`;

const Dot = styled.div`
    width: 8px;
    height: 8px;
    position: absolute;
    background-color: ${colors.red};
    right: 0;
    top: 0;
    border-radius: 4px;
`;

export default Header;
